<template>
  <section class="credits-how-it-work  container">
    <div class="credits-how-it-work__content container-inner">
      <h2 class="credits-how-it-work__title">{{ $tCredits('How it work') }}</h2>
      <div class="credits-how-it-work__list">
        <div v-for="(item, index) in section"
             :key="index"
             class="credits-how-it-work__item">
          <img :src="item.icon"
               :alt="item.text"
               class="credits-how-it-work__item-ico">
          <h3 class="credits-how-it-work__item-name">{{ item.text }}</h3>
        </div>
      </div>
      <CreditsPageAdvantagesBtn class="credits-how-it-work__btn"/>
    </div>
  </section>
</template>

<script>
  import CreditsPageAdvantagesBtn from './common/CreditsPageAdvantagesBtn'

  export default {
    name: 'CreditsPageHowItWork',
    components: {
      CreditsPageAdvantagesBtn
    },
    props: {
      section: Array
    },
    data() {
      return {}
    }
  }
</script>

<style lang="less">

</style>